import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '@brg/ui';
import {
  PlateBestText,
  PlateBottomSection,
  PlateChoiceText,
  PlateContainer,
  PlateText,
  PlateTopSection,
} from './RatingImgGenerate';

type ZharKnigaAwardsPlateBadgeProps = {
  isGridPlate?: boolean;
  onhoverPlate?: boolean;
};

export const ZharKnigaAwardsPlateBadge: FC<ZharKnigaAwardsPlateBadgeProps> = ({
  isGridPlate,
  onhoverPlate,
}) => {
  const { t } = useTranslation();

  const plateHoverStyle = {
    opacity: onhoverPlate ? 0 : 1,
    visibility: onhoverPlate ? 'hidden' : 'visible',
    transition: isGridPlate
      ? 'opacity 0.1s ease, visibility 0.3s ease'
      : 'opacity 0.3s ease, visibility 0.3s ease',
  } as const;

  return (
    <PlateContainer style={plateHoverStyle} isGridPlate={isGridPlate}>
      <PlateTopSection isGridPlate={isGridPlate}>
        <PlateChoiceText isGridPlate={isGridPlate}>
          {t('competition.zharkniga_awards_plate_line1')}
        </PlateChoiceText>
        <PlateBestText isGridPlate={isGridPlate} $accentColor={Colors.white}>
          {t('competition.zharkniga_awards_plate_line2')}
        </PlateBestText>
      </PlateTopSection>
      <PlateBottomSection isGridPlate={isGridPlate} $accentColor={Colors.hotRed}>
        <PlateText isGridPlate={isGridPlate}>
          {t('competition.zharkniga_awards_plate_bottom')}
        </PlateText>
      </PlateBottomSection>
    </PlateContainer>
  );
};
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '@brg/ui';
import {
  PlateBestText,
  PlateBottomSection,
  PlateChoiceText,
  PlateContainer,
  PlateText,
  PlateTopSection,
} from './RatingImgGenerate';

type ZharKnigaAwardsPlateBadgeProps = {
  isGridPlate?: boolean;
  onhoverPlate?: boolean;
};

export const ZharKnigaAwardsPlateBadge: FC<ZharKnigaAwardsPlateBadgeProps> = ({
  isGridPlate,
  onhoverPlate,
}) => {
  const { t } = useTranslation();

  const plateHoverStyle = {
    opacity: onhoverPlate ? 0 : 1,
    visibility: onhoverPlate ? 'hidden' : 'visible',
    transition: isGridPlate
      ? 'opacity 0.1s ease, visibility 0.3s ease'
      : 'opacity 0.3s ease, visibility 0.3s ease',
  } as const;

  return (
    <PlateContainer style={plateHoverStyle} isGridPlate={isGridPlate}>
      <PlateTopSection isGridPlate={isGridPlate}>
        <PlateChoiceText isGridPlate={isGridPlate}>
          {t('competition.zharkniga_awards_plate_line1')}
        </PlateChoiceText>
        <PlateBestText isGridPlate={isGridPlate} $accentColor={Colors.white}>
          {t('competition.zharkniga_awards_plate_line2')}
        </PlateBestText>
      </PlateTopSection>
      <PlateBottomSection isGridPlate={isGridPlate} $accentColor={Colors.hotRed}>
        <PlateText isGridPlate={isGridPlate}>
          {t('competition.zharkniga_awards_plate_bottom')}
        </PlateText>
      </PlateBottomSection>
    </PlateContainer>
  );
};
